import styled, { css } from 'styled-components';
import { ArrowRight } from '@styled-icons/bootstrap/ArrowRight';
import { device } from 'constants/breakpoints';
export const Container = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 3000px;
  overflow: hidden;
  box-sizing: border-box;

  .deckgl-wrapper {
    cursor: default !important;
  }
  .st-desktop-only {
    display: none;
  }

  .st-mobile-only {
    display: block;
  }

  ${({ isMobile }) => !isMobile &&
    `
    @media ${device.desktop} {
    .st-desktop-only {
      display: block;
    }
    .st-mobile-only {
      display: none;
    }
  }

    @media ${device.desktop} {
      padding-left: 400px;
      width: 100%;
      transition: width 0.125s ease;
    }
  `}

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    font-family: Lato;
    margin: 0 !important;
    margin-top: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-bottom: 0 !important;
    padding: 0 !important;
    padding-top: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-bottom: 0 !important;
  }

  div:empty {
    display: block !important;
  }

  div.deck-tooltip {
    display: none !important;
  }

  * {
    box-sizing: border-box !important;
  }

  *:after,
  *:before {
    box-sizing: border-box !important;
  }
`;
const mobileStyles = css `
  .mapboxgl-map {
    .mapboxgl-ctrl-bottom-left {
      bottom: 0;
      right: 8px;
      left: auto;
    }

    .mapboxgl-ctrl-bottom-right {
      bottom: -5px;
      right: 88px;
    }
  }
`;
export const MapBoundary = styled.div `
  position: relative;
  height: ${({ theme }) => theme.distances.mobileMapHeight}px;
  width: 100%;
  overflow: hidden;

  ${({ isMobile }) => !isMobile &&
    `
    @media ${device.desktop} {
    height: 100%;
    top: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
    `}

  @media ${device.mobile} {
    ${mobileStyles}
  }

  ${({ isMobile }) => isMobile && mobileStyles}
`;
export const NextStepButton = styled.div `
  position: absolute;
  margin-top: -20px;
  left: 5px;
  background: #fff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 30px;
  padding: 4px 16px;
  font-size: 12px;
  z-index: 5;
`;
export const StyledArrow = styled(ArrowRight) `
  margin-left: 4px;
  color: ${({ theme }) => theme.palette.grey[400]};
`;
export const BreadCrumbContainer = styled.div `
  position: absolute;
  z-index: 9;
  top: 10px;
`;
